<template>
  <template v-if="!vpnConnectionStatus.configured && !setupInitiated">
    <div class="warning-block d-flex align-center mb-4 py-1 px-4">
      <v-icon class="mr-3" icon="$warning" />
      <span class="body2">{{ $t("network.initialSetup.bannerDescription") }}</span>
    </div>
    <virtual-office-setup @setup-submitted="setupInitiated = true"></virtual-office-setup>
  </template>
  <virtual-office-creation-failed-banner v-else-if="vpnConnectionStatus.creationFailed" />
  <empty-state v-else class="margin-auto mt-12 w-65">
    <template #icon>
      <v-icon class="empty-state-icon mr-1" icon="$addonNetwork"> </v-icon>
    </template>
    <template #description><span v-html="$t('network.noData.title')"></span></template>
    <template #subtitle>
      <span v-html="$t('network.noData.subtitle')"></span>
    </template>
    <template #button>
      <a class="d-inline-flex align-center flex-grow-0" :href="supportLink" target="_blank">
        <v-icon size="18" class="mr-1" icon="$help"></v-icon>
        <span class="body2 coro-link">{{ $t("network.noData.contactSupport") }}</span>
      </a>
    </template>
  </empty-state>
</template>

<script lang="ts">
import { defineComponent, ref } from "vue";
import { useVirtualOfficeStore } from "@/_store/network/virtual-office.module";
import { storeToRefs } from "pinia";
import EmptyState from "@/components/EmptyState.vue";
import VirtualOfficeSetup from "@/components/network/VirtualOfficeSetup.vue";
import VirtualOfficeCreationFailedBanner from "@/components/network/VirtualOfficeCreationFailedBanner.vue";

export default defineComponent({
  components: { EmptyState, VirtualOfficeSetup, VirtualOfficeCreationFailedBanner },
  setup() {
    const virtualOfficeStore = useVirtualOfficeStore();
    const { vpnConnectionStatus } = storeToRefs(virtualOfficeStore);
    const setupInitiated = ref(false);
    const supportLink = "https://docs.coro.net/";

    return {
      supportLink,
      vpnConnectionStatus,
      setupInitiated,
    };
  },
});
</script>

<style lang="scss" scoped>
.empty-state-icon {
  font-size: 80px !important;
}

:deep(*) {
  .icon-network-l::before {
    color: rgb(var(--v-theme-indigo-light)) !important;
  }
}
.icon-help-xs::before {
  color: rgb(var(--v-theme-link));
}
</style>
